import React from 'react';
import { func } from 'prop-types';
import { Menu } from 'antd';

import { Popconfirm } from '../../components/popovers';
import { SvgIcon } from '../../components/svg-icon';
import {
  DropdownItem,
  DropdownList,
  DropdownAction,
  DropdownContent,
} from '../../components/ui-helpers';


export const ActionDropdown = ({
  onEdit,
  onDelete,
}) =>
  (
    <Menu style={{ padding: 0, borderRadius: '4px', borderRight: 'unset' }}>
      <DropdownContent width={100}>
        <DropdownList>
          <DropdownItem>
            <DropdownAction onClick={onEdit}>
              <SvgIcon type="pencil" />
              Edit
            </DropdownAction>
          </DropdownItem>

          <DropdownItem>
            <Popconfirm
              okType="danger"
              okText="Yes"
              cancelText="No"
              title="Are you sure delete this item?"
              onConfirm={onDelete}
            >
              <DropdownAction data-popconfirm-stay-open>
                <SvgIcon type="trash" width={14} />
                Delete
              </DropdownAction>
            </Popconfirm>
          </DropdownItem>
        </DropdownList>
      </DropdownContent>
    </Menu>
  );

ActionDropdown.propTypes = {
  onEdit: func.isRequired,
  onDelete: func.isRequired,
};



// WEBPACK FOOTER //
// ./src/modals/add-meeting-notes-modal/action-dropdown.js